export default function Footer() {
  return (
    <div className="w-full -my-12 sm:-my-8 text-center">
      <p className="text-xs">jonathan chen {new Date().getFullYear()}</p>
    </div>
  );
}
